import { PostIncidentCreateUpdate, IncidentBodyData, HttpTokens } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description create/update Incident, for draft or published status, we use the same api for both
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const IncidentCreateUpdatePost = (
  /** create can also refer to update for draft */
  prefix: string = 'incidents/create-update',
  tokens: HttpTokens,
  body: IncidentBodyData,
  hardRejection = true
): Promise<PostIncidentCreateUpdate> => {
  const instance = new AxiosService({ method: 'post', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  console.log('[incidents/create-update][@body/json]', JSON.stringify(body));

  return instance.client
    .post(`${prefix}`, JSON.stringify(body), config)
    .then((d: AxiosResponse<PostIncidentCreateUpdate>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<PostIncidentCreateUpdate>;
};
